<template>
  <div data-app>
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button
        class="md-primary md-simple md-dense"
        @click="snackbar.show = false"
        >Dismiss</md-button
      >
    </md-snackbar>
    <group-card title="Income/Expense" icon="equalizer" padded>
      <template slot="actions">
        <md-checkbox
          class="md-layout-item md-size-10"
          v-model="isReferrerFiltering"
        >
          Show by Referrer
        </md-checkbox>

        <validated-autocomplete-input
          label="By Referrer"
          class="md-small-size-10 md-size-10 mr-5"
          :options="filteredReferrers.map((i) => i.name)"
          v-model="selected_referrer"
          :disabled="!isReferrerFiltering"
        ></validated-autocomplete-input>&nbsp;
        <validated-autocomplete-input
          label="By Pod"
          class="md-small-size-10 md-size-10 mr-5"
          :options='filteredPods'
          v-model="selected_pod"
          @item-selected="getBillings(true)"
          :disabled="isReferrerFiltering"
        ></validated-autocomplete-input>&nbsp;
        <validated-select-input
          class="md-small-size-10 md-size-10"
          :options="year_list"
          v-model="selected_year"
        ></validated-select-input>
        <loading-icon-button
          @click="getBillings(true)"
          tooltip="Fetch Billings"
          :loading="progress_indicator.billings"
        >
          get_app
        </loading-icon-button>
      </template>
      <md-tabs md-alignment="centered" :md-active-tab="current_month">
        <md-tab
          v-for="month in month_list"
          :key="month"
          :id="month"
          :md-label="month"
          @click="selected_month = month"
        ></md-tab>
      </md-tabs>
      <div data-app>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="activeBillingHeaders"
          :items="billings"
          v-model="selected_bills"
          item-key="id"
          :show-select="showSelect"
          :search="search"
          :items-per-page="10"
          class="elevation-0 broker_table"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'first_page',
            lastIcon: 'last_page',
            prevIcon: 'skip_previous',
            nextIcon: 'skip_next',
            itemsPerPageOptions: [10, -1],
            itemsPerPageText: '',
          }"
          :loading="progress_indicator.billings"
          :loading-text="loading_text"
        >
          <!--SDB-565 comment out the change-->
          <!-- <template v-slot:item.compliance="{ item }">
            <div v-if="item.billing_type=== 'internal sales income' || item.billing_type === 'external sales income'">
                <md-icon class="icon-danger" v-if="!item.compliance">unpublished</md-icon>
                <md-icon class="icon-success" v-if="item.compliance">check_circle</md-icon>
            </div>
          </template> -->
          <template v-slot:item.application_id="{ item }">
            <md-tooltip md-direction="top">
              Open Application: {{ item.application_id }}
            </md-tooltip>
            <md-button
              class="md-primary md-simple"
              @click="openApplication(item.application_id)"
              v-if="item.application_id"
            >
              {{ item.application_id }}
            </md-button>
          </template>
          <template v-slot:item.created_date="{ item }">
            {{ item.created_date | datetime }}
          </template>
          <template v-slot:item.amount="{ item }">
            {{ item.amount | currency }}
          </template>
          <template v-slot:item.amount="{ item }">
            <div :class="getColor(item.billing_type)">
              {{ item.amount }}
            </div>
          </template>
        </v-data-table>
      </div>
      <md-card-actions>
        <!-- Commented during task SDB-534 not necessary at this moment for removing in future -->
        <!-- <md-switch v-model="showHideReferralRecords">
          Show/Hide Referral Records
        </md-switch> -->
        <md-button
          @click="confirmInvalidateSelectedBills"
          class="md-icon-button"
        >
          <md-icon>{{ selectedRecordType === 'Invalid' ? 'note_add' : 'insert_page_break' }}</md-icon>
          <md-tooltip md-direction="top">{{ selectedRecordType === 'Invalid' ? 'Mark selected bills as valid' : 'Mark selected bills as invalid' }}</md-tooltip>
        </md-button>
        <validated-autocomplete-input
          label="Select Record Type"
          class="md-small-size-10 md-size-10 mr-5"
          :options="recordTypes"
          v-model="selectedRecordType"
        ></validated-autocomplete-input>&nbsp;
        <!-- Commented on task SDB-534 for future implementation -->
        <!-- <md-switch v-model="totalReferralAmountSwitch"> -->
        <!-- Total summary of all referrers -->
        <!-- </md-switch> -->
        <md-button
          class="md-primary"
          @click="deleteBills"
          v-if="!showHideDeleted && selected_bills.length > 0"
        >
          <md-icon>delete_forever</md-icon>
          Delete
        </md-button>
        <md-button
          class="md-primary"
          @click="readyForSync"
          v-if="!showHideDeleted"
        >
          <md-icon>upload</md-icon>
          Upload to XERO
        </md-button>
        <md-button class="md-primary" @click="restoreBills" v-else>
          <md-icon>restore</md-icon>
          Restore
        </md-button>
        <md-button
          class="md-primary"
          @click="openRCTIModal"
        >
          <md-icon>visibility</md-icon>
          View RCTI
        </md-button>
      </md-card-actions>
      <div class="d-flex">
       <v-autocomplete
          v-model="selected_pods"
          :items="getPods"
          dense
          filled
          chips
          small-chips
          label="Stage/Status"
          multiple
          item-value="id"
          :open-on-clear="true"
          ref="pods"
          @blur="blurDropdown('pods')"
        >
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @mousedown.prevent
              @click="toggle()"
            >
              <v-list-item-action>
                <v-icon>
                  {{ statusIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="{ index }" v-if="allStatus">
            <v-chip v-if="index === 0">
              <span>Select All</span>
            </v-chip>
          </template>
        </v-autocomplete>
         <md-button
          class="md-primary"
          :disabled="bulkLoading"
          @click="downloadBulkRCTI(false)"
        >
          <md-icon>visibility</md-icon>
          Download Bulk RCTI
        </md-button>
        <md-button
          class="md-primary"
          @click="show_bulk_email_dialog = true"
        >
          <md-icon>visibility</md-icon>
          Send Bulk RCTI
        </md-button>
      </div>
    </group-card>

    <!-- Warranty Income Table -->
    <WarrantyIncomeBillings
      :selected-warranty-bills="selected_warranty_bills"
      @update:selectedWarrantyBills="updateWarrantyBills"
      :year="selected_year"
      :month="monthInt"
      :pod="selected_pod"
    />

    <group-card title="Adjustment List" icon="money" padded>
      <template slot="actions">
        <md-button class="md-primary" @click="restoreAdjustments">
          <md-icon>restore</md-icon>
          Restore Adjustment
        </md-button>
        <md-button
          @click="openNewAdjustment"
          class="md-icon-button md-primary md-simple new-app-button"
        >
          <md-icon id="new-app-icon">note_add</md-icon>
            New Adjustment
          <md-tooltip md-direction="top">Add new Adjustment</md-tooltip>
        </md-button>
        <loading-icon-button
          @click="fetchPodAdjustments(true)"
          tooltip="Refresh"
          :loading="progress_indicator.adjustment_list"
        >
          refresh
        </loading-icon-button>
      </template>

      <!-- Adjustment Details Editor -->
      <md-dialog :md-active.sync="progress_indicator.add_adjustment_dialog">
          <md-dialog-title>{{progress_indicator.dialog_title}}</md-dialog-title>
          <div v-if="errorMessage != '' && errorMessage != null">
            <p class="errorMsg">{{ errorMessage }}</p>
          </div>
          <div class="md-layout">
             <!-- Pod -->
            <div class="md-layout-item md-small-size-100 md-size-20">
              <v-autocomplete
                v-model="new_adjustment.pod_data"
                :items="allPods"
                label="Pod *"
                :selected="new_adjustment.pod_data"
                item-text="name"
                item-value="id"
                @change="setPod(new_adjustment.pod_data)"
              ></v-autocomplete>
            </div>
            <!-- Broker -->
            <div class="md-layout-item md-small-size-100 md-size-25">
              <v-autocomplete
                v-model="new_adjustment.broker_data"
                :items="allBrokers"
                label="Broker *"
                :selected="new_adjustment.broker_data"
                item-value="id"
                item-text="full_name"
                @change="setBroker(new_adjustment.broker_data)"
              >
              </v-autocomplete>
            </div>
            <!-- Adjustment Type -->
            <validated-autocomplete-input
              class="md-layout-item md-small-size-100 md-size-20"
              label="Adjustment Type"
              v-model="new_adjustment.adjustment_type"
              :options="adjustment_type_values"
              required
              force
            >
            </validated-autocomplete-input>
            <!-- Amount -->
            <validated-number-input
              class="md-layout-item md-small-size-100 md-size-30"
              label="Amount"
              prefix="$"
              v-model="new_adjustment.amount"
              required
            >
            </validated-number-input>
            <!-- Description -->
            <validated-text-input
              class="md-layout-item md-small-size-100 md-size-35"
              label="Description"
              v-model="new_adjustment.description"
            >
            </validated-text-input>
            <div class="md-layout-item md-small-size-100 md-size-20">
              <search-text-input
                label="Search Loan ID"
                icon="search"
                v-model="adjLoanId"
                :searcher="performSearch"
                @select="selectLoandId"
                min-length="3"
                force
              >
                <template v-slot="{ item }">
                  <!-- Display the matching result in the template -->
                  <div class="result-row">
                    <p>Application ID: {{ item.applicationId }}</p>
                    <p>Customer Name: {{ item.customerName }}</p>
                  </div>
                </template>
              </search-text-input>
            </div>
            <validated-text-input
              class="md-layout-item md-small-size-100 md-size-20"
              label="Customer Name"
              v-model="adjCustomerName"
              disabled
            >
            </validated-text-input>
            <div class="md-layout-item md-small-size-100 md-size-10">
              <md-field>
                  <label>Month</label>
                  <md-select id="month" v-model="adjustmentMonth"
                    >
                    <md-option v-for="item in months" v-bind:key="item" :value="item">
                      {{ item }}
                    </md-option>
                  </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-10">
              <md-field>
                <label>Year</label>
                <md-select id="year" v-model="adjustmentYear">
                  <md-option v-for="item in years" v-bind:key="item" :value="item">
                      {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <md-dialog-actions>
            <md-button
              class="md-primary md-simple"
              @click="onAddAdjustmentCancel"
              >Cancel</md-button
            >
            <md-button
              class="md-primary md-simple"
              @click="createAdjustment"
              :disabled="!adjustment_selected_pod || !adjustment_selected_broker || !new_adjustment.adjustment_type || !new_adjustment.amount ">
              Save
            </md-button>
          </md-dialog-actions>
      </md-dialog>

      <md-dialog :md-active.sync="show_rcti">
        <md-dialog-title>RCTI - {{ selected_pod }} - {{ selected_month }} - {{ selected_year }}</md-dialog-title>
        <md-dialog-content>
          <iframe :src="pdfUrl" style="width: 60vw; height: 70vh;"></iframe>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button
            class="md-primary"
            @click="showEmailDialog"
          >
            <md-icon>send</md-icon>
            Send
          </md-button>
          <md-button class="md-primary" @click="closeRCTIModal">Close</md-button>
        </md-dialog-actions>
      </md-dialog>
      <md-dialog :md-active.sync="show_email_dialog">
        <md-dialog-title>Enter Email Address</md-dialog-title>
        <md-dialog-content>
          <div class="md-layout-item">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="rctiMailAddress"></md-input>
              </md-field>
          </div>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary" @click="sendRctiPDF">
            <md-icon>send</md-icon>
            Send Email
          </md-button>
          <md-button class="md-primary" @click="show_email_dialog = false">Cancel</md-button>
        </md-dialog-actions>
      </md-dialog>

       <md-dialog :md-active.sync="show_bulk_email_dialog">
        <md-dialog-title>Enter Email Body</md-dialog-title>
        <md-dialog-content>
          <div class="md-layout-item">
              <md-field>
                <label>Enter custom message</label>
                <md-textarea v-model="rctiMailBody"></md-textarea>
              </md-field>
          </div>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary" @click="downloadBulkRCTI(true)" :disabled="bulkLoading">
            <md-icon>send</md-icon>
            Send Email
          </md-button>
          <md-button class="md-primary" @click="show_bulk_email_dialog = false">Cancel</md-button>
        </md-dialog-actions>
      </md-dialog>
      <!-- Adjustment Listing Table -->
      <v-data-table
          :headers="adjustmentHeaders"
          :items="podAdjustments"
          v-model="selectedAdjustments"
          item-key="id"
          show-select
          :search="search"
          :items-per-page="10"
          class="elevation-0 broker_table"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'first_page',
            lastIcon: 'last_page',
            prevIcon: 'skip_previous',
            nextIcon: 'skip_next',
            itemsPerPageOptions: [10, -1],
            itemsPerPageText: '',
          }"
          :loading="progress_indicator.adjustment_list"
          :loading-text="loading_text"
        >
        <template v-slot:item.deleted_at="{ item }">
          {{ item.deleted_at | datetime }}
        </template>
        <template v-slot:item.actions="{ item }">
          <loading-icon-button
            @click="editAdjustment(item)"
            tooltip="Edit Adjustment"
            :loading="progress_indicator.edit_adjustment_id == item.id"
          >
            edit
          </loading-icon-button>
          <loading-icon-button
            @click="removeAdjustment(item)"
            tooltip="Delete Adjustment"
            :loading="progress_indicator.remove_adjustment_id == item.id"
          >
            clear
          </loading-icon-button>
        </template>
      </v-data-table>
    </group-card>

    <group-card title="Summary" icon="summarize" padded>
      <div class="md-layout">
        <div
          class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25"
        >
          <traffic-light-card title="Total Transaction" status="information">
            <traffic-light-item secondary="">
              {{ totals.sum | currency }}
            </traffic-light-item>
          </traffic-light-card>
        </div>
        <div
          class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25"
        >
          <traffic-light-card title="Income">
            <traffic-light-item secondary="">
              {{ totals.income | currency }}
            </traffic-light-item>
          </traffic-light-card>
        </div>
        <div
          class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25"
        >
          <traffic-light-card title="Expense" status="neutral">
            <traffic-light-item secondary="">
              {{ totals.expense | currency }}
            </traffic-light-item>
          </traffic-light-card>
        </div>

        <div
          class="md-layout-item md-medium-size-33 md-small-size-50 md-size-25"
        >
          <traffic-light-card title="Adjustment">
            <traffic-light-item secondary="">
              {{ total_adjustment | currency }}
            </traffic-light-item>
          </traffic-light-card>
        </div>
      </div>
    </group-card>
    <group-card title="Administrative Tools" icon="sync" padded>
      <template slot="actions">
        <md-switch v-model="showExtra">Show Administrative Actions</md-switch>
      </template>
      <div class="boxed-category" v-if="showExtra">
        <md-subheader>Xero Synchronization</md-subheader>
          <div class="md-layout">
            <div class="md-layout-item">
              <md-button class="md-primary" @click="show_register_info = true">
                <md-icon>app_registration</md-icon>
                Register App with XERO
              </md-button>
            </div>
            <div class="md-layout-item">
              <md-button class="md-primary" @click="syncTrackingCategory">
                <md-icon>location_searching</md-icon>
                Sync Tracking Category
              </md-button>
            </div>
            <div class="md-layout-item">
              <md-button class="md-primary" @click="syncXeroContact">
                <md-icon>contacts</md-icon>
                Sync Contacts
              </md-button>
            </div>
          </div>
      </div>
      <!-- Start: DocuSign Registration -->
      <div class="boxed-category" v-if="showExtra">
        <md-subheader>DocuSign Synchronization</md-subheader>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-card-actions>
              <md-button class="md-primary" @click="docuSignRegisterApp">
                <md-icon>app_registration</md-icon>
                Register App with DocuSign
              </md-button>
            </md-card-actions>
          </div>
        </div>
      </div>
       <!-- END: DocuSign Registration -->
      <!-- Start: Broker's Finalization Cut off Time -->
      <div class="boxed-category" v-if="showExtra">
        <md-subheader>Broker's Finalization Cut off Time</md-subheader>
        <div class="md-layout">
          <md-card>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Select Cut Off Day</label>
                <md-select id="month" v-model="cutOffDay">
                  <md-option v-for="day in days_list" v-bind:key="day" :value="day">
                    {{ day }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <md-card-actions>
              <md-button class="md-primary" @click="saveCutOffDay">
                <md-icon>save</md-icon>
                Save
              </md-button>
            </md-card-actions>
          </md-card>
        </div>
      </div>
      <!-- END:  Broker's Finalization Cut off Time  -->
      <!-- Start: Import suncorp csv-->
      <administrate-accounting-suncorp-actions :show-extra="showExtra"/>
      <!-- End: Import suncorp CSV-->
    </group-card>
      <md-dialog-alert
        :md-active.sync="notification_alert.show"
        :md-content="notification_alert.message"
        :md-title="notification_alert.title"
        md-confirm-text="Close"
      />

    <md-dialog
      :md-active.sync="loading_alert.show"
      :md-click-outside-to-close="false"
      :md-close-on-esc="false"
    >
      <md-dialog-title>{{ loading_alert.title }}</md-dialog-title>
      <md-dialog-content>
        <span>
          {{ loading_alert.message }}
          <md-progress-bar md-mode="indeterminate"></md-progress-bar>
        </span>
      </md-dialog-content>
    </md-dialog>

    <md-dialog
      :md-active.sync="show_register_info"
      :md-click-outside-to-close="false"
      :md-close-on-esc="false"
    >
      <md-dialog-title>Registering an Application</md-dialog-title>
      <md-dialog-content>
        <p>
          You will be redirected to Xero Authorization Page. Once there select
          the organization you want to link and click Allow Access
        </p>
        <p>
          You should be then redirected to Callback page where you will be able
          to see the token.
        </p>
        <md-card-actions>
          <md-button class="md-primary" @click="registerApp">
            <md-icon>app_registration</md-icon>
            Register App with XERO
          </md-button>
        </md-card-actions>
        <p>
          This automatically saves the token in the database but not the Tenant
          ID (i.e. organization id that you want to use with this app).
        </p>
        <md-card-actions>
          <md-button class="md-primary" @click="getOrganisations">
            <md-icon>business</md-icon>
            Get Tenant Details
          </md-button>
        </md-card-actions>
        <table class="data-table wide">
          <thead>
            <tr>
              <td>Tenant Name</td>
              <td>Tenant ID</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tenant in tenants">
              <td>{{ tenant.tenant_name }}</td>
              <td>{{ tenant.tenant_id }}</td>
            </tr>
          </tbody>
        </table>
        <p></p>
        <p>
          <b
            >Copy the Tenant ID for the organization you want to use and paste
            it in .env (XERO_TENANT_ID).</b
          >
        </p>
      </md-dialog-content>
      <md-card-actions>
        <md-button class="md-primary" @click="show_register_info = false">
          Close
        </md-button>
      </md-card-actions>
    </md-dialog>
  </div>
</template>
<script>
import filters from "@/components/utils/filters";
import { GroupCard } from "@/components";
import { mapGetters } from "vuex";
import TrafficLightCard from "@/components/Cards/TrafficLightCard.vue";
import TrafficLightItem from "@/components/Cards/TrafficLightItem.vue";
import LoadingIconButton from "@/components/LoadingIconButton";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import moment from "moment";
import ValidatedSelectInput from "../components/ValidatedInput/ValidatedSelectInput";
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";
import AlertDialog from "../components/Dialogs/AlertDialog.vue";
import WaitingDialog from "../components/Dialogs/WaitingDialog.vue";
import ValidatedAutocompleteInput from "../components/ValidatedInput/ValidatedAutocompleteInput";
import ValidatedInputs from "@/components/ValidatedInput";
import { newAdjustment } from "../schema";
import WarrantyIncomeBillings from "@/pages/WarrantyIncomeBillings";
import AdministrateAccountingSuncorpActions from "./AdministrateAccountingSuncorpActions.vue";

export default {
  components: {
    ValidatedAutocompleteInput,
    ValidatedSelectInput,
    ...ValidatedInputs,
    GroupCard,
    LoadingIconButton,
    LoadingIconTextButton,
    TrafficLightCard,
    TrafficLightItem,
    WarrantyIncomeBillings,
    WaitingDialog,
    AdministrateAccountingSuncorpActions,
  },
  filters: {
    ...filters,
  },
  data() {
    return {
      filteredPods: [],
      recordTypes: ['New Records', 'Old Records', 'Invalid'],
      selectedRecordType: 'New Records',
      showSelect: true,
      month_list: moment.monthsShort(),
      days_list: Array.from({ length: 31 }, (_, i) => i + 1),
      selected_year: moment().year(),
      selected_month: moment().format("MMM"),
      adjustmentYear: '',
      adjustmentMonth: '',
      current_month: moment().format("MMM"),
      billings: [],
      filteredReferrers:[],
      cutOffDay: null,
      selected_referrer: "",
      isReferrerFiltering: false,
      // totalReferralAmountSwitch: false,
      //filteredAdjustments: [],
      podAdjustments: [],
      availableAdjustments: [],
      total_adjustment: 0,
      selectedAdjustments: [],
      totals: [],
      allPods: [],
      allBrokers: [],
      adjLoanId: "",
      adjCustomerName: "",
      search: "",
      showExtra: false,
      errorMessage : null,
      snackbar: {
        show: false,
        icon: "done",
        content: "",
      },
      progress_indicator: {
        billings: false,
        add_adjustment_dialog: false,
        edit_adjustments: false,
        edit_adjustment_id: false,
        remove_adjustment_id: false,
        dialog_title: "Add Adjustment",
      },
      new_adjustment: newAdjustment(),
      pdfUrl: '',
      selected_bills: [],
      selected_bills_id: [],
      selected_warranty_bills: [],
      notification_alert: {
        message: "",
        show: false,
        title: "",
      },
      show_register_info: false,
      show_rcti: false,
      rctiMailAddress: '',
      show_email_dialog: false,
      show_bulk_email_dialog: false,
      rctiMailBody: '',
      tenants: [],
      loading_alert: {
        message: "",
        show: false,
        title: "",
      },
      adjustmentHeaders: [
        { text: "", align: "start", value: "selected_adjustments"},
        { text: "ID", value: "id", align: "center" },
        { text: "Pod", value: "pod_name", align: "center"},
        { text: "Broker", value: "broker_name", align: "center"},
        { text: "Adjustment Type", value: "adjustment_type", align: "center"},
        { text: "Amount", value: "amount", align: "center"},
        { text: "Sent To Xero Date", value: "deleted_at", align: "center"},
        { text: "Description", value: "description",align: "center"},
        { text: "Actions", value: "actions", width: "130px", optional: false, align: "center"}
      ],
      loading_text:
        this.billings == null ? "No Records" : "Loading... Please wait",
      billingHeaders: [
        {
          text: "",
          align: "start",
          value: "selected_bills",
        },
        { text: "Billed At", value: "created_date" },
        {
          text: "Bill ID",
          sortable: true,
          value: "id",
        },
        {
          text: "Loan Application",
          sortable: true,
          value: "application_id",
        },
        { text: "Settlement Date", value: "settlement_date" },
        { text: "Status", value: "status" },
        { text: "Customer Name", value: "customer_name" },
        { text: "Billed Against", value: "name" },
        { text: "User Pod", value: "user_pod" },
        { text: "Product", value: "billing_name" },
        { text: "Referrer Name", value: "referrer_name" },
        // {text: 'Billing Type', value: 'billing_type'},
        { text: "Referrer Name", value: "referrer_name" },
        { text: "Amount", value: "amount" },
        // {text: 'Compliance', value:'compliance', align: 'center'},
      ],
      showHideDeleted: false,
      selectAll: false,
      selected_pod: "",
      showHideReferralRecords: false,
      adjustment_selected_pod : "",
      adjustment_selected_broker : "",
      activeBillingHeaders: [],
      totalBillingHeaders: [
        { text: "Referrer Name", value: "referrer_name", align: "center" },
        { text: "Total Amount", value: "total_amount", align: "center"  },
      ],
      selected_pods: [],
      bulkLoading: false,
    }
  },

  methods: {
    toggle () {
        this.$nextTick(() => {
            if (this.selected_pods.length === this.getPods.length) {
                this.selected_pods = []
            } else {
                this.selected_pods = [];
                for (let i in this.getPods) {
                    this.selected_pods.push(this.getPods[i])
                }
            }
        });
    },
    blurDropdown(event) {
        this.$refs[event].isMenuActive = false;
    },
    selectedMonthYearAdjustment() {
      this.adjustmentMonth = this.selected_month;
      this.adjustmentYear = this.selected_year;
    },
    async downloadBulkRCTI (send_email) {
        try {
            this.bulkLoading = true;
            // Send data to generate pdf
            const response = await axios.post('/api/v1/send-bulk-rcti', {
                filtered_bills: this.selected_bills,
                filtered_adjustments: this.selectedAdjustments,
                filtered_warranty_bills: this.selected_warranty_bills,
                selected_pod: this.isReferrerFiltering ? this.selected_referrer : this.selected_pod,
                selected_month: this.monthInt,
                selected_year: this.selected_year,
                is_referrer_filtering: this.isReferrerFiltering,
                force: false,
                showDeleted: this.selectedRecordType === 'Old Records',
                showInvalid: this.selectedRecordType === 'Invalid',
                selected_referrer: this.selected_referrer_computed,
                selected_pods: this.selected_pods,
                email_body: this.rctiMailBody,
                send_email: send_email
            });

            if (response.status === 200) {
                this.showNotification("Success", send_email ? "Email sent successfully" : "Please check your email", true);
                this.bulkLoading = false;
            }
        } catch (err) {
            console.error(err);
            this.showNotification("Error", "Could not generate content for RCTI Pdf.", true);
            this.resetAllBills();
            this.bulkLoading = false;
        }
    },
    performSearch(query) {
      try {
        const uniqueResults = [];

        for (let i = 0; i < this.billings.length; i++) {
          const currentBill = this.billings[i];

          // Check if the query matches the id or is included in the application_id
          if (currentBill.application_id && currentBill.application_id.includes(query)) {
            // Check if the application ID is not already in uniqueResults
            const isDuplicate = uniqueResults.some(result => result.applicationId === currentBill.application_id);

            // If not a duplicate, push the result into array
            if (!isDuplicate) {
              uniqueResults.push({
                customerName: currentBill.customer_name,
                applicationId: currentBill.application_id
              });
            }
          }
        }
        return uniqueResults;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async selectLoandId(result) {
      try {
        this.adjLoanId = result.applicationId;
        this.adjCustomerName = result.customerName;
        // Check if new_adjustment.description already has some data
        if (this.new_adjustment.description) {
          // Append the new values to the beginning of the existing string
          this.new_adjustment.description = this.adjLoanId + "-" + this.adjCustomerName + ", " + this.new_adjustment.description;
        } else {
          this.new_adjustment.description = this.adjLoanId + "-" + this.adjCustomerName;
        }
      } catch(error) {
        console.error(error);
      }
    },
    setPod(pod) {
      this.adjustment_selected_pod = pod;
      this.adjustment_selected_broker = '';
      this.getAllBrokers();
    },
    setBroker(broker) {
      this.adjustment_selected_broker = broker;
    },
    openAdjustment(adjustment) {
      this.$emit("open-adjustment", adjustment);
    },
    deleteAdjustment(adjustment) {
      this.$emit("delete-adjustment", adjustment);
    },
    openNewAdjustment() {
      this.new_adjustment = newAdjustment();
      this.selectedMonthYearAdjustment();
      this.adjLoanId = '';
      this.adjCustomerName = '';
      this.progress_indicator.add_adjustment_dialog = true;
      this.adjustment_selected_pod = "";
      this.adjustment_selected_broker = "";
      this.progress_indicator.dialog_title = "Add Adjustment";
      this.getAllPods();
    },
    async getAllPods() {
      try {
        const response = await axios.get("/api/v1/administration/user_pods");
        this.allPods = response.data;
      } catch(error) {
          console.error('User Pod fetch request failed');
          console.error(error);
      }
    },
    async getAllBrokers() {
      try {
          const response = await axios.post("/api/v1/administration/brokers_by_pod/"+ this.adjustment_selected_pod);
          this.allBrokers = response.data;
      } catch(error) {
          console.error('Broker fetch request failed');
          console.error(error);
      }
    },
    onAddAdjustmentCancel() {
      this.progress_indicator.add_adjustment_dialog = false;
    },
    /* getFilteredAdjustments() {
      const allAdjustments = this.savedAdjustments();

      // Filter the adjustments based on selected year, month, and pod
      return allAdjustments.filter(item => {

        // If bill_date is null set it to created_at
        if (!item.bill_date) {
          item.bill_date = new Date(item.created_at);
        }

        const itemDate = new Date(item.bill_date);

        // Extract the year and month from the item's date
        const itemYear = itemDate.getFullYear();
        const itemMonth = itemDate.toLocaleString('en-US', { month: 'short' });

        return (
          itemYear == this.selected_year &&
          itemMonth == this.selected_month &&
          item.pod_name === this.selected_pod
        );
      });
    }, */
    /* async refreshAdjustment(force = false) {
      this.total_adjustment = 0;
      this.progress_indicator.adjustment_list = true;
      try {
        await this.$store.dispatch("fetch_administration_adjustments", force);
        this.filteredAdjustments = this.getFilteredAdjustments();
        const adjustmentAmounts = this.filteredAdjustments.map((adjust) => {
          return filters.float(adjust.amount);
        });
        this.total_adjustment = adjustmentAmounts.reduce((total, amount) => total + amount, 0);
      } catch(error) {
        console.error("Error fetching or processing adjustments:", error);
      }
      this.progress_indicator.adjustment_list = false;
    }, */
    async createAdjustment() {
      if (this.adjustment_selected_pod == '') {
        this.errorMessage = "Please select pod";
      } else if (this.adjustment_selected_broker == '') {
        this.errorMessage = "Please select broker";
      } else {
        if (typeof this.new_adjustment.broker_data === 'object') {
          this.new_adjustment.broker_data = this.new_adjustment.broker_data.id;
        }
        if (typeof this.new_adjustment.pod_data === 'object') {
          this.new_adjustment.pod_data = this.new_adjustment.pod_data.id;
        }
        this.new_adjustment.bill_date = this.getAdjustmentDate();
        axios.post(
           `/api/v1/administration/adjustments`,
          this.new_adjustment
        ).then((res) => {
          this.progress_indicator.add_adjustment_dialog = false;
          this.snackbar.content = "Adjustment saved successfully";
          this.snackbar.icon = "done";
          this.snackbar.show = true;
          //this.refreshAdjustment(true);
          this.fetchPodAdjustments(true);
        }).catch((err) => {
          let errorData = JSON.parse(err.response.data);
          let errorMessage = Object.values(errorData).map(err => `${err.message}`).join("");
          if (errorMessage === '') {
              errorMessage = JSON.stringify(err.response);
          }
          this.errorMessage = errorMessage;
        });
      }
    },
    async removeAdjustment(adjustment) {
      this.progress_indicator.adjustment_list = true;
      try {
        await axios.get(
          `/api/v1/administration/delete_adjustments/${adjustment.id}`
        );
        //this.refreshAdjustment(true);
        this.fetchPodAdjustments(true);
      } catch (error) {
        console.error("Adjustment delete request failed");
        console.error(error);
      }
    },
    async editAdjustment(adjustment) {
      try{
        this.adjLoanId = '';
        this.adjCustomerName = '';
        this.selectedMonthYearAdjustment();
        this.getAllPods();
        this.progress_indicator.load_adjustment_id = adjustment.id;
        let { data: adjustmentRes } = await axios.get(`/api/v1/administration/adjustments/${adjustment.id}`);
        this.new_adjustment = adjustmentRes;
        this.new_adjustment.pod_data = {id: parseInt(this.new_adjustment.pod_data.id), name: this.new_adjustment.pod_data.name};
        this.new_adjustment.broker_data = {id: parseInt(this.new_adjustment.broker_data.id), name: this.new_adjustment.broker_data.name};
        this.progress_indicator.add_adjustment_dialog = true;
        this.adjustment_selected_pod = parseInt(this.new_adjustment.pod_data.id);
        this.getAllBrokers();
        this.adjustment_selected_broker = parseInt(this.new_adjustment.broker_data.id);
        this.progress_indicator.dialog_title = `Edit Adjustment`;
      } catch (error) {
        console.error('Error editing adjustment:', error);
      }
    },
    async getReferralBillings() {
      this.progress_indicator.billings = true;
      this.showLoading("Loading referral billings","Please wait...",true);
      this.resetSettingsToOriginalBillings();
      const response = await this.$store.dispatch("get_referral_billings", {
        selected_year: this.selected_year,
        selected_month: this.monthInt,
      });
      if (response) {
        this.billings = this.savedBillings()["bills"];
        this.totals = this.savedBillings()["total"];
        this.progress_indicator.billings = false;
      }
      this.showLoading("","",false);
      this.selected_bills = this.selectedBills();
      if (this.selected_bills.length > 0) {
        this.showHideDeleted = false;
      }
    },
    // Commented on task SDB-534 for future implementation
    // async getTotalReferralAmount() {
    //   try {
    //     this.showLoading("Loading total by referrer","Please wait...",true);
    //     const response = await this.$store.dispatch("get_total_referral_amount", {
    //     selected_year: this.selected_year,
    //     selected_month: this.monthInt,
    //     });
    //     if (response) {
    //       this.billings = this.savedBillings()["bills"];
    //       this.totals = this.savedBillings()["total"];
    //       this.activeBillingHeaders = this.totalBillingHeaders;
    //       this.showSelect = false;
    //     }
    //   } catch (error) {
    //     console.log('Error: getTotalReferralAmount: ' + error);
    //     this.resetSettingsToOriginalBillings();
    //   }
    //   this.showLoading("","",false);
    // },
    getAdjustmentDate () {
      const currentDate = new Date();

      // Get the month index, defaulting to the current month if not provided
      const monthIndex = this.adjustmentMonth ? moment().month(this.adjustmentMonth).month() : currentDate.getMonth();

      // Get the selected year, defaulting to the current year if not provided
      const year = this.adjustmentYear ? this.adjustmentYear : currentDate.getFullYear();

      // Create a Date object for the last day of the selected year and month
      const lastDayOfSelectedMonth = new Date(year, monthIndex + 1, 0); // Get the last day of the month

      // Format the last day of the month to ISO format
      return lastDayOfSelectedMonth.toISOString();
    },
    async confirmInvalidateSelectedBills() {
      let numberOfBills = this.selected_bills.length;
      if (numberOfBills <= 0) { return; }

      let message = `These ${numberOfBills} bill(s) will be marked as invalid. Are you Sure ?`;
      if (this.selectedRecordType === 'Invalid') {
        message = `These ${numberOfBills} bill(s) will be marked as valid. Are you sure?`;
      }
      let response = await this.$modal.show(ConfirmDialog, {
        title: "Confirm",
        important: message,
        confirmText: "Okay",
        cancelText: "Cancel",
      });
      if (response) {
        await this.invalidateSelectedBills();
      }
    },
    async invalidateSelectedBills() {
      try {
        this.progress_indicator.billings = true;
        const billingIds = this.selected_bills.map(bill => bill.id);
        const response = await axios.post('/api/v1/administration/update_billings', {
          billing_ids: billingIds,
          isInvalid: this.selectedRecordType === 'Invalid'
        });
        if (response.data.success) {
          this.selected_bills = [];
          await this.getBillings(true);
        } else {
          console.error(response.data.error);
        }
      } catch (error) {
        console.error("Error invalidating billings:", error);
      } finally {
        this.progress_indicator.billings = false;
      }
    },
    async getBillings(force = false) {
      try {
        this.resetAllBills();
        this.progress_indicator.billings = true;
        //this.refreshAdjustment(true);
        this.fetchPodAdjustments(true);
        this.resetSettingsToOriginalBillings();
        const response = await this.$store.dispatch("get_billings", {
          force: force,
          showDeleted: this.selectedRecordType === 'Old Records',
          showInvalid: this.selectedRecordType === 'Invalid',
          selected_year: this.selected_year,
          selected_month: this.monthInt,
          selected_pod: this.selected_pod,
          selected_referrer: this.selected_referrer_computed,
          is_referrer_filtering: this.isReferrerFiltering,
        });
        if (response) {
          this.setupBillings();
        }
        if (this.selected_bills.length > 0) {
          this.showHideDeleted = false;
        }
      } catch (error) {
        console.error(error);
      }
      this.progress_indicator.billings = false;
    },
    setupBillings() {
      this.billings = (this.savedBillings()["bills"] || []).filter(billing => billing.application_id !== null);
      this.totals = this.savedBillings()["total"] ?? [];
    },
    resetSettingsToOriginalBillings() {
      this.activeBillingHeaders = this.billingHeaders;
      this.showSelect = true;
      // this.totalReferralAmountSwitch = false;
    },
    openApplication(application_id) {
      if (application_id) {
        let url = `/application/${application_id}/capture`;
        window.open(url, "_blank").focus();
      }
    },
    async readyForSync() {
      // Selected Income/Expense + Adjustments
      let numTotalBillsSelected = this.selected_bills.length + this.selectedAdjustments.length + this.selected_warranty_bills.length;
      // All Income/Expense + Adjustments filtered by date and pod - count
      let unUploadedWarrantyBills = this.warranty_billings.filter((bill) => !bill.deleted_at);
      let numTotalFilteredBills =  this.billings.length + this.availableAdjustments.length + unUploadedWarrantyBills.length;

      let numberOfBills =
      numTotalBillsSelected > 0
          ? numTotalBillsSelected
          : numTotalFilteredBills;

      let response = await this.$modal.show(ConfirmDialog, {
        title: "Confirm",
        important: `Do you wish to upload ${numberOfBills} item/s in RCTI ?`,
        confirmText: "Upload RCTI",
        cancelText: "Cancel",
      });

      if (response) {
        this.syncToXero();
      }
    },
    async restoreBills() {
      let numberOfBills =
        this.selected_bills_id.length > 0
          ? this.selected_bills.length
          : this.billings.length;
      let response = await this.$modal.show(ConfirmDialog, {
        title: "Confirm",
        important: `Do you wish to restore ${numberOfBills} item/s?`,
        confirmText: "Restore",
        cancelText: "Cancel",
      });
      if (response) {
        this.showLoading(
          "Restoring Records",
          "Please wait while the records are being restored.",
          true
        );
        try {
          const response = await axios.post("/api/v1/xero/restore_bills", {
            selected_bills: this.selected_bills_id,
          });
          if (response != false) {
            await this.getBillings(true);
            this.showNotification("Success", "Records Restored", true);
          }
        } catch (error) {
          console.log(error);
          this.showNotification("Error", "Could not restore bills.", true);
        }
      }
      this.resetAllBills();
    },
    async restoreAdjustments() {
      let response = await this.$modal.show(ConfirmDialog, {
        title: "Confirm",
        important: `Do you wish to restore selected adjustment/s?`,
        confirmText: "Restore",
        cancelText: "Cancel",
      });
      if (response) {
        this.showLoading(
          "Restoring Adjustment",
          "Please wait while the adjustments are being restored.",
          true
        );
        try {
          let selectedAdjustmentsBillsIds = this.selectedAdjustments.map((adjustment) =>  parseInt(adjustment.billing_id, 10));
          const response = await axios.post("/api/v1/xero/restore_bills", {
            selected_bills: selectedAdjustmentsBillsIds,
          });
          if (response != false) {
            await this.getBillings(true);
            this.showNotification("Success", "Adjustments Restored", true);
          }
        } catch (error) {
          console.log(error);
          this.showNotification("Error", "Could not restore bills.", true);
        }
      }
      this.resetAllBills();
    },
    async getNonEmptyPods() {
      // Only get pods with billings, otherwise get all pod options.
      await axios.get('/api/v1/administration/user_pods_with_billing')
      .then((res) => {
        if (res.data) {
          this.filteredPods = res.data
        }
      })
      .catch((err) => {
        console.error(err)
      }).finally(() => {
        if (!this.filteredPods.length) {
          this.filteredPods = this.options.user_pods
        }
      })
    },
    async deleteBills() {
      let numberOfBills =
        this.selected_bills_id.length > 0
          ? this.selected_bills.length
          : this.billings.length;
      let response = await this.$modal.show(ConfirmDialog, {
        title: "Confirm",
        important: `Do you wish to delete ${numberOfBills} item/s?`,
        confirmText: "Delete",
        cancelText: "Cancel",
      });
      if (response) {
        this.showLoading(
          "Restoring Records",
          "Please wait while the records are being deleted.",
          true
        );
        try {
          const response = await axios.post("/api/v1/xero/delete_bills", {
            selected_bills: this.selected_bills_id,
          });
          if (response != false) {
            await this.getBillings(true);
            this.showNotification("Success", "Records Deleted", true);
          }
        } catch (error) {
          console.log(error);
          this.showNotification("Error", "Could not delete records.", true);
        }
      }
      this.selected_bills = [];
    },
    async syncToXero() {
      this.showLoading(
        "Uploading Invoices",
        "Please wait while the invoices are being uploaded to Xero",
        true
      );
      let response = "";
      try {
        if (this.isReferrerFiltering) {
          //if selected_bills_id is empty, then get the id of all the bills from billings array
          this.selected_bills_id =
            this.selected_bills_id.length > 0
              ? this.selected_bills_id
              : this.billings.map((bill) => bill.id);
          response = await axios.post("/api/v1/xero/sync_referral_bills", {
            selected_bills: this.selected_bills_id,
            selected_pod: this.selected_pod,
            selected_month: this.monthInt,
            selected_year: this.selected_year,
          });
        } else {
          let selected_adjustments_bills_ids = this.selectedAdjustments.map((adjustment) =>  parseInt(adjustment.billing_id, 10));
          let selected_warranty_bills_ids = this.selected_warranty_bills.map((bill) => parseInt(bill.id, 10));
          let combined_selected_bills_ids = [...selected_adjustments_bills_ids, ...selected_warranty_bills_ids, ...this.selected_bills_id];
          if (combined_selected_bills_ids.length == 0) {
            let all_adjustments_bills_ids = this.availableAdjustments.map((adjustment) => parseInt(adjustment.billing_id, 10));
            let undeleted_warranty_bills = this.warranty_billings.filter((bill) => !bill.deleted_at);
            let all_warranty_bills_ids = undeleted_warranty_bills.map((bill) => parseInt(bill.id, 10));
            let all_bills_ids = this.billings.map((bill) => bill.id);
            combined_selected_bills_ids = [...all_adjustments_bills_ids, ...all_warranty_bills_ids, ...all_bills_ids];
          }
          // Sync Income list with Xero
          response = await axios.post("/api/v1/xero/sync_bills", {
            selected_bills: combined_selected_bills_ids,
            selected_pod: this.selected_pod,
            selected_month: this.monthInt,
            selected_year: this.selected_year,
          });
        }
        if (response.status === 200) {
          await this.getBillings(true);
          this.showNotification("Success", "Invoices uploaded to Xero", true);
          this.resetAllBills();
        }
      } catch (error) {
         console.log(error, 'error');
         this.showNotification("Error", "Could not upload bills.", true);
         this.resetAllBills();
      }
    },
    async syncTrackingCategory() {
      this.showLoading(
        "Syncing Tracking Codes & Categories",
        "Please wait while the process is being completed",
        true
      );
      try {
        const response = await axios.post(
          "/api/v1/xero/sync_tracking_category"
        );
        if (response != false) {
          this.showNotification("Success", "Tracking Codes Updated", true);
        }
      } catch (error) {
        console.log(error);
        this.showNotification(
          "Error",
          "Could not update tracking codes.",
          true
        );
      }
    },
    async syncXeroContact() {
      this.showLoading(
        "Syncing Contact Names and Codes",
        "Please wait while the process is being completed",
        true
      );
      try {
        const response = await axios.post("/api/v1/xero/sync_xero_contacts");
        if (response != false) {
          this.showNotification("Success", "Contacts Updated", true);
        }
      } catch (error) {
        console.log(error);
        this.showNotification("Error", "Could not update contacts.", true);
      }
    },
    async registerApp() {
      this.showLoading("Registering", "Please wait....", true);
      try {
        const response = await axios.post("/api/v1/xero/register_app");
        if (response != false) {
          window.open(response.data, "_blank");
          this.showNotification(
            "Authorization Process",
            "Token Retrieved and Saved",
            true
          );
        }
      } catch (e) {
        this.showNotification(
          "Error",
          "Sorry could not generate authorization link",
          true
        );
        console.log(e);
      }
    },
    async docuSignRegisterApp() {
      this.showLoading("Registering", "Please wait....", true);
      try {
        const response = await axios.get("/api/v1/docusign/register_app");
        if (response != false) {
          window.open(response.data, "_blank");
          this.showNotification(
            "Authorization Process",
            "Token Retrieved and Saved",
            true
          );
        }
      } catch (e) {
        this.showNotification(
          "Error",
          "Sorry could not generate authorization link",
          true
        );
        console.log(e);
      }
    },
    async getOrganisations() {
      try {
        const response = await axios.post("/api/v1/xero/get_organizations");
        if (response != false) {
          this.tenants = response.data;
        }
      } catch (e) {}
    },
    showNotification(title, message, flag) {
      this.loading_alert.show = false;
      this.notification_alert = {
        message: message,
        show: flag,
        title: title,
      };
    },
    showLoading(title, message, flag) {
      this.loading_alert = {
        message: message,
        show: flag,
        title: title,
      };
    },
    getColor(type) {
      if (type == "Expense") {
        return "expense-class";
      }
      if (type == "Income") {
        return "income-class";
      }
      return "";
    },
    async getOptionsReferrer() {
      await axios.get('/api/v1/administration/referrers_with_billing')
      .then((res) => {
        if (res.data) {
          this.filteredReferrers = res.data.filteredReferrerName
        }
      })
      .catch((err) => {
        console.error(err)
      })
    },
    getChecked(item) {
      return this.selected_bills.includes(item);
    },
    async openRCTIModal() {
      await this.generateRctiContent();
    },
    closeRCTIModal() {
      this.show_email_dialog = false;
      this.show_rcti = false;
      this.resetAllBills();
    },
    async showEmailDialog() {
      await this.getAllPods();

      const matchingPod = this.allPods.find(item => item.name === this.selected_pod);
      if (matchingPod) {
        this.rctiMailAddress = matchingPod.pod_contact_email;
      } else {
        this.rctiMailAddress = '';
        console.error('No email found with selected pod name');
      }
      this.show_email_dialog = true;
    },
    closeEmailDialog() {
      this.show_email_dialog = false;
      this.show_rcti = false;
      this.resetAllBills();
    },
    async sendRctiPDF() {
      // Email PDF RCTI
      try {
        const response = await axios.post('/api/v1/email-pdf', {
          responseType: 'blob',
          rcti_email_address: this.rctiMailAddress,
          filtered_bills: this.selected_bills,
          filtered_adjustments: this.selectedAdjustments,
          filtered_warranty_bills: this.selected_warranty_bills,
          is_referrer_filtering: this.isReferrerFiltering,
          selected_pod: this.isReferrerFiltering ? this.selected_referrer : this.selected_pod,
          selected_month: this.monthInt,
          selected_year: this.selected_year
        });

        if (response.status === 200) {
          this.showNotification("Succcess", `Email has been succesfully sent to ${this.rctiMailAddress}`, true);
          this.closeEmailDialog();
        }
      } catch (err) {
        console.error(err);
        this.showNotification("Error", `Email could not be sent to ${this.rctiMailAddress}`, true);
        this.closeEmailDialog();
      }
    },
    resetAllBills(){
      this.selected_bills = [];
      this.selectedAdjustments = [];
      this.selected_warranty_bills = [];
    },
    async loadCutOffDay() {
      try {
        const success = await this.$store.dispatch('get_cut_off_day');

        if (success) {
          this.cutOffDay = this.$store.state.cut_off_day;
        } else {
          console.error('Request not succesfull loading cut off day');
        }
      } catch (error) {
        console.error('Error loading cut off day:', error);
      }
    },
    async saveCutOffDay() {
      try {
        const success = await this.$store.dispatch('save_cut_off_day', this.cutOffDay);

        if (success) {
          this.showNotification(
            "Success",
            `Cut-off day has been successfully set to ${this.cutOffDay}.`,
            true
          );
        } else {
          this.showNotification('Error', `Failed to save the cut-off day to ${this.cutOffDay}.`);
        }
      } catch (error) {
        console.error('Error saving cut off day:', error);
        this.showNotification(
          "Error",
          `An unexpected error occurred while saving the cut-off day to ${this.cutOffDay}.`,
          true
        );
      }
    },
    async generateRctiContent() {
      try {
        // Send data to generate pdf
        const response = await axios.post('/api/v1/generate-content-pdf', {
          filtered_bills: this.selected_bills,
          filtered_adjustments: this.selectedAdjustments,
          filtered_warranty_bills: this.selected_warranty_bills,
          selected_pod: this.isReferrerFiltering ? this.selected_referrer : this.selected_pod,
          selected_month: this.monthInt,
          selected_year: this.selected_year,
          is_referrer_filtering: this.isReferrerFiltering,
        });

        if (response.status === 200) {
          // Show Pdf
          this.show_rcti = true;
          this.pdfUrl = `data:application/pdf;base64,${response.data.pdfContent}`;
        }
      } catch (err) {
        console.error(err);
        this.showNotification("Error", "Could not generate content for RCTI Pdf.", true);
        this.resetAllBills();
      }
    },
    async fetchPodAdjustments(force=false) {
      try {
        if (force) {
          let response = await axios.post("/api/v1/administration/getPodAdjustments", {
            selected_year: this.selected_year,
            selected_month: this.monthInt,
            selected_pod: this.selected_pod,
          });
          this.podAdjustments = response.data;
        }
        this.availableAdjustments = this.podAdjustments.filter((item) => item.deleted_at == null);
        const adjustmentAmounts = await Promise.all(
          this.availableAdjustments.map(async (adjust) => {
            return await filters.float(adjust.amount);
          })
        );
        this.total_adjustment = adjustmentAmounts.reduce((total, amount) => total + amount, 0);
      } catch (err) {
        console.log(err);
      }
    },
    updateWarrantyBills(newVal) {
      this.selected_warranty_bills = newVal;
    },
  },
  created() {
    //this.refreshAdjustment(true);
  },
  computed: {
    ...mapGetters({
      savedBillings: "getBillings",
      selectedBills: "getSelectedBills",
      options: "options",
      savedAdjustments: "administrationAdjustments",
      warranty_billings: "warranty_billings",
    }),
    months() {
      const current_day = new Date().getDate();
      let months = [];
      // Show selected by default
      months.push(this.selected_month)
      if (current_day <= 15 && this.selected_month === this.current_month) {
        // Allow user to select previous month if before 16
        months.push(moment().subtract(1, 'months').format("MMM"));
      }

      return months;
    },
    years() {
      const current_year = moment().year();
      let years = [];
      // Show selected by default
      years.push(this.selected_year);
      if (this.current_month === 1 && this.selected_month === this.current_month) {
        // Just allow user to select previous year if january
        years.push(current_year - 1);
      }

      return years;
    },
    selected_referrer_computed() {
       return this.filteredReferrers.find(ref => ref.name === this.selected_referrer);
    },
    year_list() {
      let current_year = moment().year();
      let yearList = [];
      let numberOfPastYears = 10;
      for (let i = 0; i <= numberOfPastYears; i++) {
        yearList.push(current_year - i);
      }
      return yearList;
    },
    monthInt() {
      return (
        parseInt(
          Object.keys(this.month_list).find(
            (key) => this.month_list[key] === this.selected_month
          )
        ) + 1
      );
    },
    isButtonDisabled() {
      if (this.showHideDeleted || this.billings == undefined) {
        return true;
      }
      return false;
    },
    adjustment_type_values() {
      return Object.values(this.options.adjustment_types);
    },
    getPods() {
      return this.filteredPods ?? []
    },
    someStatus () {
      return this.selected_pods.length > 0 && !this.allStatus
    },
    allStatus () {
      return this.selected_pods.length === this.getPods.length
    },
    statusIcon() {
      if (this.allStatus) return 'mdi-close-box'
      if (this.someStatus) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  watch: {
    // Commented on task SDB-534 for future implementation
    // totalReferralAmountSwitch: function () {
    //   if (this.totalReferralAmountSwitch) {
    //     this.getTotalReferralAmount();
    //   } else {
    //     this.getBillings(true);
    //   }
    // },
    showHideReferralRecords: function () {
      if (this.showHideReferralRecords) {
        this.getReferralBillings();
      } else {
        this.getBillings(true);
      }
    },
    selected_referrer: function () {
      this.getBillings(true);
    },
    isReferrerFiltering: function () {
      if (this.isReferrerFiltering) {
        this.selected_pod = '';
      } else {
        this.selected_referrer = '';
      }
      this.getBillings(true);
    },
    showExtra: function () {
      return this.showExtra;
    },
    selectedRecordType: function () {
      this.showHideDeleted = this.selectedRecordType === 'Old Records';
      this.getBillings(true);
    },
    selected_bills: function () {
      //set the billings id from the bills
      vue.$store.commit("selected_bills", this.selected_bills);
      this.selected_bills_id = this.selected_bills.map(function (bill) {
        return bill.id;
      });
      if (this.selected_bills.length == 0) {
        this.setupBillings();
      } else {
        this.totals.sum = this.totals.income = this.totals.expense = 0;
        const self = this;
        this.selected_bills.forEach(function (bill) {
          self.totals.sum += filters.float(bill.amount);
          if (bill.billing_type == "Expense") {
            self.totals.expense += Math.abs(filters.float(bill.amount));
          }
          if (bill.billing_type == "Income") {
            self.totals.income += filters.float(bill.amount);
          }
        });
      }
    },
    selected_month: function () {
      this.showLoading("Loading billings","Please wait...",true);
      this.getBillings(true);
      this.selected_bills = [];
      this.selectedAdjustments = [];
      this.showLoading("","",false);
    },
    selected_year: function () {
      this.getBillings(true);
      this.selected_bills = [];
      this.selectedAdjustments = [];
    },
    selectAll: function () {
      if (this.selectAll) {
        this.selected_bills = (this.savedBillings()["bills"] || []).filter(billing => billing.application_id !== null);
      } else {
        this.selected_bills = [];
      }
    },
    selectedAdjustments: function () {
      if (this.selectedAdjustments.length > 0) {
        this.total_adjustment = this.selectedAdjustments.reduce((acc, cur) => {
          return acc + filters.float(cur["amount"]);
        }, 0);
      } else {
        this.fetchPodAdjustments(false)
      }
    },
  },
  created() {
    this.getNonEmptyPods();
  },
  async mounted() {
    this.activeBillingHeaders = this.billingHeaders;
    this.getBillings(true);
    await this.getOptionsReferrer()
    this.loadCutOffDay();
  },
  async beforeCreate() {
    const params = {
      types: [
        'user_pods',
        'adjustment_types',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.result-row {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.expense-class {
  color: darkorange;
}

.checkbox-bill {
  cursor: pointer;
  transform: scale(1.5);
}

.errorMsg {
  padding: 5px 20px;
}
.md-icon.icon-danger {
    color:  $ausloans-red;
}

.md-icon.icon-success {
    color: $ausloans-red;
}
.d-flex {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    &>* {
        margin-right: 15px;
    }
}
</style>
